import { TextField,Box } from '@mui/material'
import React,{useState} from 'react'
import { toast } from 'react-toastify'
import { auth } from '../firebaseconfig'

export const Loginform = ({handleclose}) => {
    const[email,setemail]=useState('')
    const[password,setpassword]=useState('')

    const handlesubmit =()=>{
        if(!email || !password)    
        {
            toast.warn(' All Fields mandatory!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                });
                return
        } 
        auth.signInWithEmailAndPassword(email,password).then((res)=>{
            toast.success('User logged in!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                });
                handleclose()
                return
        }).catch((err)=>{
            toast.error('User creation failed!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                });
        })
    
    }
    
    
  return (
    <Box p={3}
        style={{display:'flex',
        flexDirection:'column',
        gap:'20px',
        color:'black'

    }}
    >
        <TextField type='email' 
                    variant='outlined' 
                    label='Enter email' 
                    InputLabelProps={{style:{color:'white'}}} 
                    InputProps={{style:{color:'white'}}} 
                    onChange={(e)=>{setemail(e.target.value)}}
                    />
        <TextField type='password' 
                    variant='outlined' 
                    label='Enter password' 
                    InputLabelProps={{style:{color:'white'}}} 
                    InputProps={{style:{color:'white'}}} 
                    onChange={(e)=>{setpassword(e.target.value)}}
                    />
        <button variant='contained' 
                size='large' 
                style={{background:'dodgerblue'}}
                onClick={handlesubmit}
                >Login</button>
    </Box>
  )
}
